import s from "./styles.module.scss";

interface CollapsibleButtonProps {
	isExpanded: boolean;
}

export const CollapsibleButton = ({ isExpanded }: CollapsibleButtonProps) => (
	<span className={s.collapsibleButton}>{isExpanded ? "Hide" : "Show more"}</span>
);
